import { connect, MapDispatchToProps, MapStateToProps } from "react-redux";
import { withRouter } from "react-router-dom";
import { ThunkDispatch } from "redux-thunk";
import { isLoading, State } from "redux/state";
import { ACCEPT_INVITE, acceptInvite, AcceptInviteAction } from "routes/Organization/modules/actions";
import { Omit } from "utils/Types";
import { AcceptInvite, AcceptInviteProps } from "../components/AcceptInvite";

type AcceptInviteDispatchProps = Pick<AcceptInviteProps, "acceptInvite">;
type AcceptInviteStateProps = Pick<AcceptInviteProps, "isAcceptingInvite" | "acceptInviteError">;
type AcceptInviteOwnProps = Omit<AcceptInviteProps, "acceptInvite" | "isAcceptingInvite" | "acceptInviteError">;

const mapDispatchToProps: MapDispatchToProps<AcceptInviteDispatchProps, AcceptInviteOwnProps> = (
    dispatch: ThunkDispatch<State, undefined, AcceptInviteAction>
) => ({
    acceptInvite(inviteId) {
        dispatch(acceptInvite(inviteId, "/"));
    }
});

const mapStateToProps: MapStateToProps<AcceptInviteStateProps, AcceptInviteOwnProps, State> = (state: State) => ({
    acceptInviteError: state.org.errors[ACCEPT_INVITE],
    isAcceptingInvite: isLoading(state, ACCEPT_INVITE)
});

export default withRouter(
    connect(
        mapStateToProps,
        mapDispatchToProps
    )(AcceptInvite)
);
